// Get Comprehensive Report Use Case

import {InventoryRepository} from '../repository/InventoryRepository';

export class GetComprehensiveReportUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (filters?: any, page = 1, limit = 20): Promise<any> {
    try {
      const report = await this.inventoryRepository.getComprehensiveReport(filters, page, limit);
      return report;
    } catch (error) {
      throw error;
    }
  }
}
